import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { getFile } from "../../utils/getFile";
import config from "../../config";

const PolicyAcknowledgmentModal = ({
  show,
  onClose,
  onSubmit,
  policyDocument,
  title = "Policy Acknowledgment",
  viewOnly = false,
  acknowledgmentLabel = "Yes, I have read and acknowledge the document.",
  delaySeconds = 5,
  loader,
}) => {
  const [policyAcknowledged, setPolicyAcknowledged] = useState(false);
  const [policyRead, setPolicyRead] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);
  const [policyFile, setPolicyFile] = useState(null);

  useEffect(() => {
    let timer;
    if (show && !viewOnly) {
      setTimerStarted(true);
    }
    if (timerStarted && !policyRead) {
      timer = setTimeout(() => {
        setPolicyRead(true);
      }, delaySeconds * 1000);
    }
    return () => clearTimeout(timer);
  }, [timerStarted, policyRead, show, delaySeconds, viewOnly]);

  const handleSubmit = () => {
    if (policyAcknowledged) {
      onSubmit?.();
    }
  };

  const handleChange = (e) => {
    setPolicyAcknowledged(e.target.checked);
  };

  useEffect(() => {
    if (!show) {
      setPolicyAcknowledged(false);
      setPolicyRead(false);
      setTimerStarted(false);
    } else if (show) {
      getPolicyFile();
    }
  }, [show]);

  const getPolicyFile = async () => {
    let policyFile = null;
    if (policyDocument) {
      try {
        const imageUrl = await getFile(`${config.IMAGE_URL}${policyDocument}`);
        if (imageUrl) {
          policyFile = imageUrl;
          setPolicyFile(policyFile);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <Modal show={show} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {policyFile ? (
          <div style={{ height: "400px", border: "1px solid #ddd" }}>
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
            >
              <Viewer fileUrl={policyFile} />
            </Worker>
          </div>
        ) : (
          <p className="text-center">Policy file not found!</p>
        )}

        {!viewOnly && policyFile && (
          <>
            {!policyRead && (
              <p className="mt-3 text-danger">
                * Please read the document. Acknowledgment will be enabled in{" "}
                {delaySeconds} seconds.
              </p>
            )}
            {policyRead && (
              <Form className="m-3">
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    checked={policyAcknowledged}
                    label={acknowledgmentLabel}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Form>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        {!viewOnly && policyFile && (
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={!policyRead || !policyAcknowledged}
          >
            {loader ? "Submitting..." : "Submit"}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PolicyAcknowledgmentModal;
